import { render } from "./UserSubscriptionsTabular.vue?vue&type=template&id=3ac34c18"
import script from "./UserSubscriptionsTabular.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionsTabular.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__